var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['deadline-reminder', !_vm.deadlineExpired ? 'active' : 'expired'],style:({ backgroundColor: _vm.bgColor })},[_vm._v("The deadline "+_vm._s(_vm.deadlineExpired ? 'was' : 'is')+" "+_vm._s(_vm._f("moment")(_vm.deadlineToLocal,'LLL')))])
}
var staticRenderFns = []

export { render, staticRenderFns }